import { render, staticRenderFns } from "./ContributionsSettings.vue?vue&type=template&id=7161da12&"
import script from "./ContributionsSettings.vue?vue&type=script&lang=ts&"
export * from "./ContributionsSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports